export function getCookie(name: string): string | undefined {
  const all = typeof document !== "undefined" ? document.cookie : "";
  if (!all) return undefined;
  const parts = all.split(";");
  for (const part of parts) {
    const eq = part.indexOf("=");
    if (eq < 0) continue;
    const key = part.slice(0, eq).trim();
    if (key === name) {
      try {
        return decodeURIComponent(part.slice(eq + 1).trim());
      } catch {
        return part.slice(eq + 1).trim();
      }
    }
  }
  return undefined;
}

function cookieDomain(): string | undefined {
  if (typeof location === "undefined") return undefined;
  const host = location.hostname;
  if (!host) return undefined;
  const dot = host.indexOf(".");
  if (dot < 0) return undefined;
  const stripped = host.slice(dot + 1);
  if (stripped.indexOf(".") < 0) return undefined;
  return "." + stripped;
}

export function setCookie(
  name: string,
  value: string,
  maxAgeSeconds: number,
): void {
  if (typeof document === "undefined") return;
  const isHttps =
    typeof location !== "undefined" && location.protocol === "https:";
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    `Path=/`,
    `Max-Age=${Math.floor(maxAgeSeconds)}`,
    `SameSite=Lax`,
  ];
  const domain = cookieDomain();
  if (domain) parts.push(`Domain=${domain}`);
  if (isHttps) parts.push("Secure");
  document.cookie = parts.join("; ");
}
